module.exports = __webpack_public_path__ + "img/vote.dbcaaf63.png";